<template>
  <div v-if="!loadingData">
    <FormVue
      :edit="editForm"
      :title="titleForm"
      :product_name="productName"
      :code_sku="skuCode"
      :product_id="productId"
      :category_id="productCategoryId"
      v-if="displayForm"
      @closeModal="closeModal()"
    />
    <CategoriesManagerVue
      v-if="displayCategoriesManager"
      @closeModal="closeCategoriesManager()"
    />
    <div class="title-page flex justify-between text-center items-center">
      <div class="flex items-center">
        <feather-icon
          icon="BriefcaseIcon"
          class="text-primary"
          svgClasses="h-5 w-6"
        ></feather-icon>
        <h3
          class="font-bold ml-2 text-primary"
          style="display: inline-block; font-size: 18px"
        >
          {{ $t("myProducts") }}
        </h3>
      </div>
      <div class="flex items-center" style="gap: 0.5rem;">
        <buttonVue
          v-if="products.length"
          title="أضف منتج"
          @action="addProduct()"
        >
          <template #icon>
            <feather-icon
              icon="PlusCircleIcon"
              class="text-primary"
            ></feather-icon>
          </template>
        </buttonVue>
        <buttonVue
          title="إدارة التصنيفات"
          @action="openCategoriesManager()"
        >
          <template #icon>
            <feather-icon
              icon="ListIcon"
              class="text-primary"
            ></feather-icon>
          </template>
        </buttonVue>
      </div>
    </div>
    <div class="category-filter" style="max-width: 260px; margin-bottom: 1rem;">
      <SelectInputVue
        :options="categoryOptions"
        :default="null"
        :edit="true"
        :disabled="filterLoading"
        @input="onCategoryChange"
      />
    </div>
    <div v-if="products.length" class="products">
      <table class="product-table">
        <thead>
          <tr>
            <th> ID </th>
            <th> المنتج </th>
            <th> رمز ال sku </th>
            <th>  الكمية المتاحة </th>
            <th> جاري الشحن </th>
            <th>  تم الشحن </th>
            <th>  الاوامر </th>
          </tr>
        </thead>
        <tbody>
          <tr class="product" v-for="(product, index) in products" :key="index">
            <td> {{ product.id }} </td>
            <td> {{ product.name }} </td>
            <td> {{ product.sku }} </td>
            <td> 
              <span v-if="product.quantity > 0"> {{ product.quantity }} </span>
              <button v-else class="warning" :aria-label="'Product Quantity: ' + product.quantity">{{ product.quantity }}</button>
            </td>
            <td> {{ product.quantity_in_orders ? product.quantity_in_orders : 0 }} </td>
            <td> {{ product.delivered_quantity ? product.delivered_quantity : 0 }} </td>
            <td class="actions">
              <!-- <feather-icon icon="TrashIcon"
                svgClasses="cursor-pointer text-danger stroke-current"
                @click.stop="(modalDelete = true), (productId = product.id)"
              /> -->
              <feather-icon icon="EditIcon"
                svgClasses="cursor-pointer stroke-current"
                @click.stop="editProduct(product)"
              />            
            </td>
          </tr>
        </tbody>
      </table>
      <infinite-loading @infinite="infiniteHandler">
        <div slot="no-results" class="font-bold mb-3 text-primary">
          لا يوجد منتجات اخري        
        </div>
        <!-- <div slot="no-more" class="font-bold mb-3 text-primary">
          لا يوجد منتجات اخري
        </div>   -->
      </infinite-loading>
    </div>
    <div v-else class="empty-products">
      <img
        loading="lazy"
        src="@/assets/images/elements/no product.png"
        alt="No Products"
      />
      <h6>عفواً {{ username }}, لا يوجد منتجات مضافة</h6>
      <p>من خلال هذة الصفحة يمكنك اضافة وتعديل وحذف المنتجات</p>
      <buttonVue title="أضف الأن" @action="addProduct()">
        <template #icon>
          <feather-icon
            icon="PlusCircleIcon"
            class="text-primary"
          ></feather-icon>
        </template>
      </buttonVue>
    </div>
    <ModalDeleteVue
      v-if="modalDelete"
      @closeModal="closeModalDelete()"
      @actionDelete="deleteOneProduct()"
      :loadingAction="loadingAction"
      description="هل انت متأكد من حذف المنتج"
    />
  </div>
  <div
    v-else
    class="flex items-center justify-center w-ful"
    style="height: 100vh"
  >
    <SpinnerColor2Vue />
  </div>
</template>

<script>
import buttonVue from "../../layouts/components/button.vue";
import FormVue from "./Form.vue";
import CategoriesManagerVue from "./CategoriesManager.vue";
import ModalVue from "../../layouts/components/Modal.vue";
import ModalDeleteVue from "../../layouts/components/ModalDelete.vue";
import SelectInputVue from "../../layouts/components/SelectInput.vue";
import { mapActions, mapGetters } from "vuex";
import SpinnerColor2Vue from "../components/table-components/SpinnerColor2.vue";
import notifyState from "../../mixins/notifyState";
export default {
  mixins: [notifyState],
  data() {
    return {
      displayForm: false,
      editForm: false,
      titleForm: "",
      productName: "",
      skuCode: "",
      modalDelete: false,
      username: JSON.parse(localStorage.getItem("userData")).name,
      loadingData: false,
      loadingAction: false,
      productId: null,
      productCategoryId: null,
      selectedCategoryId: null,
      filterLoading: false,
      displayCategoriesManager: false,
    };
  },
  computed: {
    ...mapGetters("products", [
      "products",
      "next_products_url",
      "error_msg",
      "success",
      "categories",
    ]),
    categoryOptions() {
      return [{ id: null, name: "جميع التصنيفات" }, ...this.categories];
    },
  },
  components: {
    buttonVue,
    FormVue,
    CategoriesManagerVue,
    ModalVue,
    ModalDeleteVue,
    SpinnerColor2Vue,
    SelectInputVue,
  },
  methods: {
    ...mapActions("products", ["fetchProducts", "deleteProduct", "fetchCategories"]),
    addProduct() {
      this.titleForm = "إضافة منتج";
      this.editForm = false;
      this.productCategoryId = null;
      this.displayForm = true;
    },
    closeModal() {
      this.displayForm = false;
    },
    openCategoriesManager() {
      this.displayCategoriesManager = true;
    },
    async closeCategoriesManager() {
      this.displayCategoriesManager = false;
      await this.fetchCategories();
    },
    closeModalDelete() {
      this.modalDelete = false;
    },
    async deleteOneProduct() {
      this.loadingAction = true;
      await this.deleteProduct(this.productId);
      if (this.success === 1) {
        this.closeModalDelete();
        this.notifySuccess("deleteToast");
      } else {
        this.notifyFaild("faildDelete");
      }
      this.loadingAction = false;
    },
    editProduct(product) {
      this.titleForm = "تعديل منتج";
      this.editForm = true;
      this.displayForm = true;
      this.productName = product.name;
      this.skuCode = product.sku;
      this.productId = product.id;
      this.productCategoryId = product.category_id || null;
    },
    async onCategoryChange(categoryId) {
      this.selectedCategoryId = categoryId;
      this.filterLoading = true;
      await this.fetchProducts({
        reset: true,
        paginate: 10,
        categoryId: this.selectedCategoryId,
      });
      this.filterLoading = false;
    },
    async infiniteHandler($state) {
      if (!this.next_products_url) {
        $state.complete();
      } else {
        await this.fetchProducts({ isAppend: true, paginate: 4 });
        $state.loaded();
      }
    },
  },
  async created() {
    await this.fetchCategories();
    if (this.products.length == 0) {
      this.loadingData = true;
      await this.fetchProducts({ reset: true, paginate: 10 });
      this.loadingData = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_products.scss";
.warning {    
  width: 3rem;
  border: none;
  border-radius: 1.5rem;
  background-color: rgba(234, 84, 85, 0.2);
  color: #EA5455;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.loading-default {
  border: 1px solid $mainColor1 !important;
  &::before {
    background-color: $mainColor1 !important;
  }
}
</style>
